import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import {
  ApiWorkflowExecutionDetail,
  ApiWorkflowExecutionFilter,
  ApiWorkflowExecutionListItem,
  ApiWorkflowExecutionMeeting,
} from "@/types/workflows/workflow-execution.types.ts";
import { ApiWorkflowShort } from "@/types/workflows/workflow.types.ts";

export const apiWorkflowExecutions = {
  search: async function (filter: ApiWorkflowExecutionFilter, signal: AbortSignal) {
    return api.post<ApiPagedData<ApiWorkflowExecutionListItem>>(
      "/api/v1/workflow-executions/search",
      filter,
      signal
    );
  },

  getWorkflows: async function (signal?: AbortSignal) {
    return api.get<ApiWorkflowShort[]>("/api/v1/workflow-executions/workflows", {}, signal);
  },

  getById: async function (executionId: number, signal?: AbortSignal) {
    return api.get<ApiWorkflowExecutionDetail>(
      `/api/v1/workflow-executions/${executionId}`,
      {},
      signal
    );
  },

  cancelWorkflow: async function (executionId: number) {
    return api.post<ApiOperationResult>(`/api/v1/workflow-executions/${executionId}/cancel`, {});
  },

  getMeetings: async function (executionId: number, signal?: AbortSignal) {
    return api.get<ApiWorkflowExecutionMeeting[]>(
      `/api/v1/workflow-executions/${executionId}/meetings`,
      {},
      signal
    );
  },
};
